import {AlertTypes} from "@leap4/frontend";

export const styles = {
    paper: {
        marginTop: 64, // theme.spacing(8) = 8 * 8 = 64
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: 8, // theme.spacing(1) = 1 * 8 = 8
    },
    submit: {
        margin: "24px 0 16px", // theme.spacing(3, 0, 2) = "24px 0px 16px"
    },

    [AlertTypes.SUCCESS]: {
        backgroundColor: "#22c55e", // theme.palette.success.main
    },
    [String(AlertTypes.FAILURE)]: {
        backgroundColor: "#ef4444", // theme.palette.error.main
    },

    text: {
        color: "white",
        padding: 8, // theme.spacing(1) = 1 * 8 = 8
    },
} as const;

export default styles;
